import styled from 'styled-components';

export const StyledProtocolIcon = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 34px;
    height: 34px;
    background-color: ${({ theme }) => theme.color.other.lavender};
    border-radius: 4px;
`;
